// passwordcollector controlloer

/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { User } from "@common/model/user";
import { CommonService } from "@common/common.service";
import { CacheService } from "@common/service/cache.service";
import { AppService } from "@app/app.service";
import { IAppRootScopeService } from "@app/app.definition";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { PopUpService } from "@common/popup/popup.service";
import { IUserService } from "@common/service/user.service";
import { ISubjectService } from "@common/service/subject.service";
import { Util } from "@common/util";
import {
    PolicyTypeEnum,
    ValidationService,
} from "@common/service/validation.service";
import { AuthenticationService } from "@/app/authentication/services/authentication.service";
import { SnackbarService } from "../../service/snackbar.service";

// typescript namespace
export class PasswordCollectorController {
    isSignedUpUser: boolean;
    currentUser: User;
    fromProfile: any;
    resetRequired: boolean;
    resetRequiredMessage: string;
    notFirstTime: boolean;
    init: boolean;
    resetPassword: Function;
    changePass: Function;
    showCancel: Function;
    showLoader: boolean | string;
    password: string;
    passwordCollectorMessage: string;

    passwordExpiryDays: string;

    resetNewPassword: string;
    resetNewRepeatPassword: string;

    newPassword: string;
    oldPassword: string;
    newRepeatPassword: string;
    errorMessage: string;
    TOS_TEXT: string;
    TOS_CHECKBOX_TEXT: string;
    tos_accepted: boolean = true;
    VAULT_KEY_TXT: string;
    vkPolicyTooltip: string = "";
    vkErrorMsg: string = "";
    corruptVk = false;
    callYes: boolean;
    newTabMsg: string;
    flag: boolean;
    GDPR_COMPLIANCE_INFO: string;
    GDPR_COMPLIANCE_DECLINE_CASE_INFO_LOGIN: string;

    placeholderOldVaultKey: string;
    placeholderNewVaultKey: string;
    placeholderConfirmNewVaultKey: string;

    static $inject = [
        "CommonService",
        "ChangePassword",
        "CreatePassword",
        "$state",
        "CacheService",
        "AppService",
        "$rootScope",
        "ApiAdapterService",
        "$uibModalInstance",
        "PopUpService",
        "fromProfile",
        "resetRequired",
        "resetRequiredMessage",
        "AuthenticationService",
        "UserService",
        "SubjectService",
        "$q",
        "$timeout",
        "SnackbarService",
        "ValidationService",
        "$sce",
    ];

    constructor(
        private $_com: CommonService,
        ChangePassword: Function,
        CreatePassword: Function,
        private $state: angular.ui.IStateService,
        private $_cache: CacheService,
        //AppService injected as its initializaton is required to access rootScope methods: logout
        private $_appServ: AppService,
        private $rootScope: IAppRootScopeService,
        private $_api: JavaApiAdapterService,
        private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private $_pop: PopUpService,
        fromProfile: Function,
        resetRequired: boolean,
        resetRequiredMessage: string,
        private authService: AuthenticationService,
        private $_user: IUserService,
        private $_subject: ISubjectService,
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService,
        private $_snack: SnackbarService,
        private ValidationService: ValidationService,
        private $sce: angular.ISCEService
    ) {
        $rootScope.mainShowLoader = false;

        //this.loader = $rootScope.mainShowLoader;
        this.isSignedUpUser = this.$rootScope.signedUpUser;
        this.currentUser = this.$_cache.getUser();
        this.fromProfile = fromProfile;
        this.resetRequired = resetRequired;
        this.resetRequiredMessage = resetRequiredMessage;
        this.callYes = false;
        this.TOS_TEXT = Util.TOS_UPDATE;
        this.TOS_CHECKBOX_TEXT = Util.TOS_CHECK_BOX;
        this.VAULT_KEY_TXT = Util.VAULT_KEY_TXT;
        this.newTabMsg = Util.OPN_NEW_TAB_MSG;
        this.flag = false;
        this.GDPR_COMPLIANCE_INFO = Util.GDPR_COMPLIANCE_INFO;
        this.GDPR_COMPLIANCE_DECLINE_CASE_INFO_LOGIN =
            Util.GDPR_COMPLIANCE_DECLINE_CASE_INFO_LOGIN;

        if (
            this.currentUser.isPrivacyPolicyUpdated ||
            this.currentUser.isTermsOfServiceUpdated ||
            this.currentUser.isGdprComplianceUpdated
        ) {
            this.tos_accepted = false;
        }

        let mainBodyHeight = $("#ecv-main-body").height();
        $timeout(function () {
            let solidBgHeight = $("#solid-bg").height();
            if (mainBodyHeight > solidBgHeight) {
                $("#solid-bg").height(mainBodyHeight + 200);
            }
        }, 300);

        let processVKPolicy = () => {
            this.vkPolicyTooltip = this.ValidationService.getHtmlTooltip(
                PolicyTypeEnum.VAULT_KEY_POLICY
            );
            this.vkErrorMsg = this.ValidationService.getPwdErrMessage(
                PolicyTypeEnum.VAULT_KEY_POLICY
            );
            this.$sce.trustAsHtml(this.vkPolicyTooltip);
            if (this.$rootScope.signedUpUser) {
                this.passwordCollectorMessage =
                    "Please enter the Vault Key you created";
            } else if (this.$_cache.getNotFirstTime() == true) {
                this.passwordCollectorMessage =
                    "Please re-enter your Vault Key";
            } else if (
                this.resetRequired == true &&
                this.resetRequiredMessage != ""
            ) {
                this.passwordCollectorMessage = this.resetRequiredMessage;
            } else if (
                this.resetRequired == true &&
                this.resetRequiredMessage == ""
            ) {
                this.passwordExpiryDays = this.ValidationService.getExipryDays(
                    PolicyTypeEnum.RESET_VAULT_KEY_POLICY
                );
                this.passwordCollectorMessage =
                    "It's been " +
                    this.passwordExpiryDays +
                    " day(s) and its time to pick a new Vault Key!";
            } else {
                this.passwordCollectorMessage = "Please enter your Vault Key";
            }
        };

        if (ChangePassword || CreatePassword || resetRequired) {
            this.$_api
                .getValidationPolicy(
                    this.currentUser.providerIdentity,
                    null,
                    PolicyTypeEnum.VAULT_KEY_POLICY
                )
                .then((policies) => {
                    this.ValidationService.setAndProcessPolicy(
                        PolicyTypeEnum.RESET_VAULT_KEY_POLICY,
                        policies.resetVaultKeyPolicy
                    );
                    this.ValidationService.setAndProcessPolicy(
                        PolicyTypeEnum.VAULT_KEY_POLICY,
                        policies.vaultKeyPolicy
                    );
                    processVKPolicy();
                });
        } else {
            processVKPolicy();
        }

        this.notFirstTime = $_cache.getNotFirstTime();
        if (typeof CreatePassword === "string" && CreatePassword === "init") {
            this.init = true;
        } else {
            this.resetPassword = CreatePassword;
            this.changePass = ChangePassword;
            this.showCancel = ChangePassword;
        }
        this.showLoader = this.$rootScope.mainShowLoader;

        if (this.resetRequired) {
            this.placeholderOldVaultKey = "Enter your current Vault key";
            this.placeholderNewVaultKey = "Pick a new Vault Key";
            this.placeholderConfirmNewVaultKey = "Re-enter your new Vault key";
        } else {
            this.placeholderOldVaultKey = "Please Enter Old Vault Key";
            this.placeholderNewVaultKey = "Please Enter New Vault Key";
            this.placeholderConfirmNewVaultKey =
                "Please Re-Enter New Vault Key";
        }
    }
    isValidVaultKey = () => {
        return this.ValidationService.isValidValue(
            PolicyTypeEnum.VAULT_KEY_POLICY,
            this.newPassword
        );
    };

    dismiss = () =>
        this.$uibModalInstance.dismiss({
            value: null,
            status: "ERROR",
        });

    close = () =>
        this.$uibModalInstance.close({
            value: this.password,
            status: "OK",
        });

    keyPress = (keyEvent) => {
        if (keyEvent.which === 13) {
            this.submit();
        }
    };

    dismissCreatePasswordFunc = () => this.$uibModalInstance.dismiss();

    cancelChangePass = () => {
        this.changePass = null;
        this.resetPassword = null;

        this.newPassword = null;
        this.oldPassword = null;
        this.newRepeatPassword = null;

        this.errorMessage = "";
    };

    changePassword = () => {
        let deferred = this.$q.defer();
        if (!this.newPassword || !this.oldPassword || !this.newRepeatPassword) {
            this.errorMessage = "All fields are required";
            this.$timeout(() => {
                deferred.reject();
            }, 500);
            return deferred.promise;
        }
        if (!this.isValidVaultKey()) {
            this.errorMessage = this.vkErrorMsg;
            this.$timeout(() => {
                $("#passwordnew").focus();
            }, 0);
            this.$timeout(() => {
                deferred.reject();
            }, 500);
            return deferred.promise;
        }

        if (this.newPassword != this.newRepeatPassword) {
            this.errorMessage = "Vault Keys do not match";
            this.$timeout(() => {
                deferred.reject();
            }, 500);
            return deferred.promise;
        } else {
            this.errorMessage = "";
            if (
                this.currentUser.isTermsOfServiceUpdated ||
                this.currentUser.isPrivacyPolicyUpdated ||
                this.currentUser.isGdprComplianceUpdated
            ) {
                if (this.tos_accepted) {
                    return this.changeVaultPassword();
                }
            } else {
                return this.changeVaultPassword();
            }
        }
        return deferred.promise;
    };

    changeVaultPassword = () => {
        let deferred = this.$q.defer();
        this.showLoader = true;
        let newPassSending = this.$_com.hashPassword(this.newPassword);
        this.$_api
            .changePassword(
                this.$_cache.getUser().userId,
                newPassSending,
                this.$_com.hashPassword(this.oldPassword)
            )
            .then(
                (s) => {
                    this.showLoader = false;
                    this.$_cache.setPassword(newPassSending);
                    this.updatePolicy()
                        .then((s) => {
                            toastr.success(
                                "Your Vault Key has been successfully changed."
                            );
                            deferred.resolve();
                        })
                        .catch((e) => {
                            console.log(e);
                            deferred.reject();
                        })
                        .finally(() => {
                            this.$uibModalInstance.close({
                                status: "changeSuccess",
                            });
                        });
                },
                (e) => {
                    this.showLoader = false;
                    if (e.indexOf(":") != -1) {
                        this.errorMessage = e.split(":")[2];
                    } else {
                        this.errorMessage = e;
                    }
                    deferred.reject();
                }
            );
        return deferred.promise;
    };

    changeVaultKeyPress = (keyEvent) => {
        if (keyEvent.which === 13) {
            this.changePassword();
        }
        return;
    };
    // close
    submit = () => {
        let deferred = this.$q.defer();
        if (this.resetRequired) {
            return this.changePassword();
        } else {
            if (!this.password || this.password.length == 0) {
                this.errorMessage = "The Vault Key cannot be left blank.";
                this.$timeout(() => {
                    deferred.reject();
                }, 500);
                return deferred.promise;
            } else {
                this.errorMessage = "";
            }
            if (
                this.currentUser.isTermsOfServiceUpdated ||
                this.currentUser.isPrivacyPolicyUpdated ||
                this.currentUser.isGdprComplianceUpdated
            ) {
                if (this.tos_accepted) {
                    this.updatePolicy().then(
                        (s) => {
                            this.authenticate()
                                .then(() => {
                                    deferred.resolve();
                                })
                                .catch(() => {
                                    deferred.reject();
                                });
                        },
                        (e) => {
                            console.log("something wrong while update policy.");
                            deferred.reject();
                        }
                    );
                } else {
                    console.log("Please accept ToS/PP");
                    this.$timeout(() => {
                        deferred.reject();
                    }, 500);
                }
            } else {
                this.authenticate()
                    .then(() => {
                        deferred.resolve();
                    })
                    .catch(() => {
                        deferred.reject();
                    });
            }
        }
        return deferred.promise;
    };

    updatePolicy = () => {
        let deferred = this.$q.defer();
        let pp_accepted = null;
        let tos_accepted = null;
        let gdpr_accepted = null;

        if (this.currentUser.isTermsOfServiceUpdated) {
            tos_accepted = this.tos_accepted;
        }

        if (this.currentUser.isPrivacyPolicyUpdated) {
            pp_accepted = this.tos_accepted;
        }

        if (this.currentUser.isGdprComplianceUpdated) {
            gdpr_accepted = this.tos_accepted;
        }

        if (
            this.currentUser.isTermsOfServiceUpdated ||
            this.currentUser.isPrivacyPolicyUpdated ||
            this.currentUser.isGdprComplianceUpdated
        ) {
            if (this.tos_accepted) {
                this.$_api
                    .policyAccepted(
                        pp_accepted,
                        tos_accepted,
                        gdpr_accepted,
                        this.currentUser.id
                    )
                    .then(
                        (s) => {
                            this.currentUser.isTermsOfServiceUpdated = false;
                            this.currentUser.isPrivacyPolicyUpdated = false;
                            this.currentUser.isGdprComplianceUpdated = false;
                            this.$_cache.setUser(this.currentUser);
                            deferred.resolve(s);
                        },
                        (e) => {
                            console.log("something wrong while update policy.");
                            deferred.reject(e);
                        }
                    );
            } else {
                console.log("Please accept ToS/PP.");
                deferred.reject({ error: "Please accept ToS/PP." });
            }
        } else {
            deferred.reject({ error: "Nothing to update" });
        }
        return deferred.promise;
    };

    authenticate = () => {
        let deferred = this.$q.defer();
        this.showLoader = true;
        //$rootScope.mainShowLoader = true;

        this.authService.refreshCredentials().then(
            (s) => {
                // check password
                this.$_api
                    .checkPassword(this.$_com.hashPassword(this.password))
                    .then(
                        (s) => {
                            this.$_cache.setPassword(
                                this.$_com.hashPassword(this.password)
                            );
                            let user = this.$_cache.getUser();
                            let userExperience =
                                this.$_cache.getUserExperience();
                            if (user) {
                                user = Object.assign(user, s);
                            } else {
                                user = s;
                            }
                            this.$_cache.setUser(s);
                            //set the organizationShortName in rootScope variable
                            // so that It will available in enterpriceLogo directive while loading the logo.
                            this.$rootScope.organizationShortName =
                                user.organizationShortName ||
                                (!!userExperience &&
                                    userExperience.sponsor.orgShortName);
                            this.showLoader = false;
                            this.$rootScope.mainShowLoader = false;
                            this.$rootScope.signedUpUser = false;
                            this.close();
                            deferred.resolve();
                        },
                        (e) => {
                            console.log("Unable to refresh the credentials.");
                            this.showLoader = false;
                            this.$rootScope.mainShowLoader = false;
                            console.log(e);
                            if (typeof e == "string") {
                                if (e.indexOf(":") != -1) {
                                    this.errorMessage = e.split(":")[1];
                                } else {
                                    this.errorMessage = e;
                                }
                            } else if (e.status == 412) {
                                this.corruptVk = true;
                            }
                            deferred.reject();
                        }
                    );
            },
            (e) => {
                this.$rootScope.mainShowLoader = true;
                this.$_cache.reset();
                this.$_user.reset();
                this.$_subject.reset();
                //Clear all toastr for analytics
                this.$_snack.clearNotificationToastr();
                this.$_api.logOut().finally((s) => {
                    this.$state
                        .go("ecare-vault", { reload: true }, { reload: true })
                        .then(() => {
                            deferred.reject();
                        });
                });
                this.$_pop.openInformationModal(
                    Util.SESSION_TIMEOUT_MSG,
                    null,
                    null,
                    null,
                    false,
                    "above-password-modal"
                );
            }
        );
        return deferred.promise;
    };

    initPasswordReset = ($event, isVkCorrupt?) => {
        $event.stopPropagation();
        $event.preventDefault();
        this.flag = false;
        this.$rootScope.mainShowLoader = true;

        let user = new User();
        user.id = this.$_user.getMyId();
        this.$_api
            .initBackupPasswordReset(user)
            .then(
                (s) => {
                    if (isVkCorrupt) {
                        this.$uibModalInstance.dismiss();
                        this.$state.go(
                            "corrupt-password-reset",
                            {},
                            { reload: true }
                        );
                    } else {
                        this.$_pop
                            .openInformationModal(
                                "Please check your e-mail for a link to reset your Vault Key.",
                                null,
                                null,
                                null,
                                false,
                                "above-password-modal"
                            )
                            .then((s) => {
                                if (!this.$_cache.getPassword()) {
                                    this.logout();
                                    this.$state.go(
                                        "ecare-vault",
                                        { reload: true },
                                        { reload: true }
                                    );
                                } else {
                                    this.showLoader = false;
                                    this.$rootScope.mainShowLoader = false;
                                }
                            });
                    }
                },
                (e) => {
                    this.$_pop
                        .openInformationModal(
                            "Unable to initiate Vault Key reset",
                            null,
                            null,
                            null,
                            false,
                            "above-password-modal"
                        )
                        .then((s) => {
                            this.logout();
                            this.$state.go(
                                "ecare-vault",
                                { reload: true },
                                { reload: true }
                            );
                        });
                }
            )
            .finally(() => {
                this.$rootScope.mainShowLoader = false;
            });
    };

    logout = () => {
        this.$rootScope.logout();
        this.$rootScope.mainShowLoader = true;
    };

    logoutUser = () => {
        this.$rootScope.logout();
    };
}

angular
    .module("eCareVault.common.passwordCollector")
    .controller("PasswordCollectorController", PasswordCollectorController);
